import { ContentContainer } from 'themes/canvas/components/ContentContainer/';

import { TPortfolioImage } from 'types/portfolio';

import { ImageWithText } from '../ImageWithText';

import s from './CanvasCancellationPolicy.module.css';

export interface CancellationPolicyProps {
  className?: string;
  cancellationPolicyText: string;
  image: TPortfolioImage | undefined;
  loading: boolean;
  showPortfolio: boolean;
}

export const CanvasCancellationPolicy = ({
  cancellationPolicyText,
  image,
  showPortfolio,
}: CancellationPolicyProps) => {
  const hasAboutText = cancellationPolicyText?.length > 0;

  if (!hasAboutText) {
    return null;
  }

  return (
    <section className={s.root}>
      <ContentContainer className={s.content}>
        <ImageWithText
          heading="CANCELLATION POLICY"
          content={cancellationPolicyText}
          image={image}
          reverseRow={true}
          showPortfolio={showPortfolio}
        />{' '}
      </ContentContainer>
    </section>
  );
};
